import type { GetterTree } from 'vuex'
import type { Emulator } from '@/types/emulator'
import type { RootState } from '@/store'
import type { DeveloperPanelState } from './types'
import { DEVELOPER_PANEL_GETTERS } from './types'

interface IDeveloperPanelGetters extends GetterTree<DeveloperPanelState, RootState> {
  [DEVELOPER_PANEL_GETTERS.GET_EMULATORS](state: DeveloperPanelState): Emulator[]
}

const getters: IDeveloperPanelGetters = {
  [DEVELOPER_PANEL_GETTERS.GET_EMULATORS](state) {
    return state.emulators
  },
}

export default getters
